import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CalendarDateModel} from "../../../models/calendar-date.model";

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit, OnChanges {
  @Input() maxDate = 60;
  @Input() doctorCalendar = false;
  date = new Date();
  daysInThisMonth: CalendarDateModel[] = [];
  daysInLastMonth: any;
  daysInNextMonth: any;
  selectedDates: CalendarDateModel[] = [];
  lightedDates: CalendarDateModel[] = [];
  monthNames: string[] = [
    'JANUARY',
    'FEBRUARY',
    'MARCH',
    'APRIL',
    'MAY',
    'JUNE',
    'JULY',
    'AUGUST',
    'SEPTEMBER',
    'OCTOBER',
    'NOVEMBER',
    'DECEMBER'];
  currentMonth: any;
  currentYear: any;
  currentDate: any;
  oneNextMonth

  @Output()
  dateSelected: EventEmitter<any> = new EventEmitter<any>();

  @Input() scheduleDates: any;
  selectedDays = [];

  @Input() calendarType: 'dialog' | any;

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.selectedDates = this.daysInThisMonth.filter(day => day.isSelected);
    this.lightedDates = this.daysInThisMonth.filter(day => day.lighted);
    this.getDaysOfMonth();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['daysInThisMonth']) {
      this.getDaysOfMonth();
    }
  }

  getDaysOfMonth() {
    this.daysInThisMonth = [];
    this.daysInLastMonth = [];
    this.daysInNextMonth = [];
    this.currentMonth = this.monthNames[this.date.getMonth()];
    this.currentYear = this.date.getFullYear();
    if (this.date.getMonth() === new Date().getMonth()) {
      this.currentDate = new Date().getDate();
    } else {
      this.currentDate = '';
    }
    const firstDayThisMonth = new Date(this.date.getFullYear(), this.date.getMonth(), 0).getDay();
    const prevNumOfDays = new Date(this.date.getFullYear(), this.date.getMonth(), 0).getDate();
    for (let i = prevNumOfDays - (firstDayThisMonth - 1); i <= prevNumOfDays; i++) {
      this.daysInLastMonth.push(i);
    }

    const thisNumOfDays = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0).getDate();
    for (let i = 0; i < thisNumOfDays; i++) {
      const date: CalendarDateModel = {
        date: i + 1,
        month: this.date.getMonth(),
        isSelected: false,
        weekDay: 0,
        valid: this.checkDateValidity(i + 1, this.date.getMonth(), this.currentYear),
        year: this.date.getFullYear()
      };
      this.daysInThisMonth.push(date);
    }

    const lastDayThisMonth = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0).getDay();
    for (let i = 0; i < (6 - lastDayThisMonth); i++) {
      this.daysInNextMonth.push(i + 1);
    }
    const totalDays = this.daysInLastMonth.length + this.daysInThisMonth.length + this.daysInNextMonth.length;
    if (totalDays < 36) {
      for (let i = (7 - lastDayThisMonth); i < ((7 - lastDayThisMonth) + 7); i++) {
        this.daysInNextMonth.push(i);
      }
    }
    this.selectedDays.forEach(selectedDay => {
      if (this.daysInThisMonth.find(date => date.date === selectedDay.date && date.month === selectedDay.month)) {
        this.daysInThisMonth.find(date => date.date === selectedDay.date && date.month === selectedDay.month).isSelected = true;
      }
    });
    for (const day of this.selectedDays) {
      // Find the corresponding object in selectedDates array
      const correspondingDate = this.selectedDates.find((date: any) => date.day === day.day && date.month === day.month);
      // If a corresponding object is found, bind isSelected property
      if (correspondingDate) {
        correspondingDate.isSelected = day.isSelected;
      }
    }
    if (this.scheduleDates) {
      this.scheduleDates.forEach(date => {
        let day = new Date(date.scheduleDate).getDate();
        if (this.date.getMonth() === new Date(date.scheduleDate).getMonth()) {
          this.daysInThisMonth.find(d => d.date === day).isSelected = true;
          this.daysInThisMonth.find(d => d.date === day).valid = this.checkDateValidity(day + 1, this.date.getMonth(), this.currentYear);
        }
      });
    }
  }

  checkDateValidity(date, month, year): boolean {
    const today = new Date();
    let maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + this.maxDate);
    const dateForCheck = new Date();
    dateForCheck.setMonth(month);
    dateForCheck.setFullYear(year);
    dateForCheck.setDate(date);

    return today <= dateForCheck && dateForCheck <= maxDate
  }

  goToLastMonth() { // TODO: fix bug
    this.date = new Date(this.date.getFullYear(), this.date.getMonth() - 1, 1);
    const reqDate = this.date.getTime();
    this.daysInThisMonth.forEach(date => {
      if (date.isSelected && this.selectedDays.find(selected => selected !== date)) {
        this.selectedDays.push(date);
      } else if (this.selectedDays.find(selected => selected === date) && !date.isSelected) {
        this.selectedDays.splice(this.selectedDays.indexOf(date), 1);
      }
    });
    // this.selectedDays = this.daysInThisMonth.filter(date => date.isSelected);
    this.getDaysOfMonth();
    this.cdr.detectChanges();
  }

  goToNextMonth() { // TODO: fix bug
    this.date = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
    const reqDate = this.date.getTime();
    this.daysInThisMonth.forEach(date => {
      if (date.isSelected && !this.selectedDays.find(selected => selected === date)) {
        this.selectedDays.push(date);
      } else if (this.selectedDays.find(selected => selected === date) && !date.isSelected) {
        this.selectedDays.splice(this.selectedDays.indexOf(date), 1);
      }
    });
    this.getDaysOfMonth();
    this.cdr.detectChanges();
  }

  selectDate(day: CalendarDateModel) {
    if (!day.valid) {
      return;
    }
    day.isSelected = !day.isSelected;
    if (day.isSelected) {
      this.selectedDates.push(day);
    } else {
      const index = this.selectedDates.findIndex(selectedDay => selectedDay.date === day.date && selectedDay.month === day.month);
      if (index !== -1) {
        this.selectedDates.splice(index, 1);
      }
    }
    this.emitSelectedDates();
  }
  
  private emitSelectedDates() {
    const selectedDates = this.selectedDates.map(day => {
      const dateValue = day.date.toString().padStart(2, '0');
      const monthValue = (day.month + 1).toString().padStart(2, '0');
      return `${monthValue}-${dateValue}-${day.year}`;
    });
    this.dateSelected.emit(selectedDates);
  }

selectAllDaysInMonth() {
  const isSelected = this.daysInThisMonth.some(day => day.isSelected);

  this.daysInThisMonth.forEach(day => {
    if (day.valid) {
      day.isSelected = !isSelected;
      // Update selectedDates array accordingly
      if (day.isSelected) {
        this.selectedDates.push(day);
      } else {
        const index = this.selectedDates.findIndex(selectedDay => selectedDay.date === day.date && selectedDay.month === day.month);
        if (index !== -1) {
          this.selectedDates.splice(index, 1);
        }
      }
    }
  });

  this.emitSelectedDates();
}
  

  findFirstSelectedDateIndex() {
    for (let i = 0; i < this.daysInThisMonth.length; i++) {
      if (this.daysInThisMonth[i].isSelected) {
        return i;
      }
    }
  }

  checkFirstSelectedDate(day: CalendarDateModel) {
    if (!day.isSelected) {
      return false;
    }
    if (day.date === 1) {
      return this.daysInThisMonth.find(d => d.date === 2).isSelected;
    } else if (day.date === this.daysInThisMonth[this.daysInThisMonth.length - 1].date) {
      return false;
    } else {
      if (this.daysInThisMonth.find(d => d.date === day.date - 1).isSelected) {
        return false;
      } else if (this.daysInThisMonth.find(d => d.date === day.date + 1).isSelected) {
        return true;
      }
    }
    return false;
  }

  checkLastSelectedDate(day: CalendarDateModel) {
    if (day.date === 1) {
      return false;
    } else if (day.date === this.daysInThisMonth[this.daysInThisMonth.length - 1].date &&
      this.daysInThisMonth.find(d => d.date === day.date - 1).isSelected) {
      return true;
    } else {
      if (this.daysInThisMonth.find(d => d.date === day.date - 1).isSelected &&
        !this.daysInThisMonth.find(d => d.date === day.date + 1).isSelected) {
        return true;
      }
    }
    return false;
  }

  checkMiddleSelectedDate(day: CalendarDateModel) {
    if (day.date === 1 || day.date === this.daysInThisMonth[this.daysInThisMonth.length - 1].date) {
      return false;
    } else if (this.daysInThisMonth.find(d => d.date === day.date - 1).isSelected &&
      this.daysInThisMonth.find(d => d.date === day.date + 1).isSelected) {
      return true;
    }
    return false;
  }

  checkCalendarMonthSwitchValidity(direction: string): boolean {
    switch (direction) {
      case 'last': {
        const date = new Date();
        // let minDate = new Date();
        // minDate.setMonth(this.monthNames.indexOf(this.currentMonth));
        return this.date <= date;
      }
      case 'next': {
        let maxDate = new Date();
        maxDate.setDate(this.maxDate);
        return this.date > maxDate;
      }
    }
  }

  selectedDay(day: any){
    if(this.scheduleDates){
      return day.isSelected;
    }
    const correspondingDate = this.selectedDates.find((date:any) => date.date === day.date && date.month === day.month);
    return correspondingDate?.isSelected
  }


  resetSelections(): void {
    this.daysInThisMonth.forEach(day => {day.isSelected = false;day.lighted = false; day.first= false; day.last=false });
    this.daysInThisMonth.forEach(day => day.lighted = false);
    this.selectedDates = [];
    this.lightedDates = [];
    this.emitSelectedDates();
  }

  resetLights(): void {
    this.daysInThisMonth.forEach(day => day.lighted = false);
  }

  selectedDayInRange(start: any, end: any){
    if (this.doctorCalendar) {
      
      // Convert start and end to Date objects for easy comparison
      const startDate = new Date(start.year, start.month, start.date);
      const endDate = new Date(end.year, end.month, end.date);
  
      // Iterate over each day in the current month displayed by the calendar
      this.daysInThisMonth.forEach(day => {
        const dayDate = new Date(day.year, day.month, day.date);
        // Check if the day is within the start and end range
        if (dayDate >= start && dayDate <= end) {
          // Mark the day as selected
          day.lighted = true;
          this.lightedDates.push(day)
          // Ensure this day is added to selectedDates if not already present
         
        }
      });

      let firstLightedIndex = this.daysInThisMonth.findIndex(day => day.lighted);
      let lastLightedIndex = this.daysInThisMonth.length - 1 - this.daysInThisMonth.slice().reverse().findIndex(day => day.lighted);

      // Assuming there is a day before and after the lighted range in the same month
      if (firstLightedIndex > 0) { // Check if there is a day before the first lighted day
        this.daysInThisMonth[firstLightedIndex - 1].first = true;
      }
      if (lastLightedIndex < this.daysInThisMonth.length - 1) { // Check if there is a day after the last lighted day
        this.daysInThisMonth[lastLightedIndex + 1].last = true;
      }

      // Reset 'first' and 'last' for days outside the current focused range
      if (firstLightedIndex > 0) {
        this.daysInThisMonth.slice(0, firstLightedIndex - 1).forEach(day => day.first = false);
      }
      if (lastLightedIndex < this.daysInThisMonth.length - 1) {
        this.daysInThisMonth.slice(lastLightedIndex + 2).forEach(day => day.last = false);
      }
  
      // Emit the newly selected dates
      // this.emitSelectedDates();
    }
  }
}
